/*
 * Copyright (c) 2023. Word Wide Generation Ltd
 */

import React from 'react'
import './TodoContainer.scss';
import { Progress } from 'reactstrap';
import { ActionTracker, TodoItem, TodoItemProps } from './TodoItem';
import { TaskWithAction } from '../../../types/setup-task';
import EnvelopesIcon from '@g17eco/images/envelopes.svg';

interface Props extends Pick<TodoItemProps, 'onAction'> {
  actions: ActionTracker;
  items: TaskWithAction[];
}

export const TodoList = (props: Props) => {
  const { items, onAction, actions } = props;
  if (items.length === 0) {
    return (
      <div>
        <img src={EnvelopesIcon} alt='No actions'/>
      </div>
    )
  }

  const itemsCompleted = items.filter(item => item.action?.completedDate);
  return (
    <>
      <Progress
        min={0}
        max={items.length}
        value={itemsCompleted.length}
        className={'my-4'}
      />
      {items.map((item) => <TodoItem
        key={item._id}
        item={item}
        actionInProgress={actions[item._id]}
        onAction={onAction}/>)}
    </>
  )
}
